import {
  MapContainer,
  TileLayer,
  useMapEvent
} from 'react-leaflet'
import { factory } from '../features/locations.js'

export default function Map ({ children }) {
  return (
    <MapContainer className='flex-6' id='map' center={factory} zoom={14} scrollWheelZoom>
      <TileLayer
        attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://tiles.stadiamaps.com/tiles/stamen_toner_background/{z}/{x}/{y}{r}.png'
      />
      {children}
      <MapClicked />
    </MapContainer>
  )
}

function MapClicked () {
  useMapEvent('click', (e) => {
    console.log(e.latlng)
  })
  return null
}
